export const CONTACT = {
  name: "Stainless Drycleaners",
  phone: "+91 95557 78844",
  phoneTel: "+919555778844",
  whatsapp: "919555778844",
  address: "D-44, Freedom Fighters Enclave, Neb Sarai, Sainik Farm, New Delhi, Delhi 110068",
  area: "South Delhi",
  turnaround: "48 hours",
  years: "16",
  hours: "Mon – Sat · 10:00 AM – 8:00 PM",
  rating: "4.2",
  reviews: "33",
};

export const WHATSAPP_URL = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(
  "Hi Stainless Drycleaners, I'd like to book a pickup. My details —\nName:\nAddress:\nService:\nPreferred date:"
)}`;

export const IMAGES = {
  hero_rack: "https://images.pexels.com/photos/20433641/pexels-photo-20433641.jpeg?auto=compress&cs=tinysrgb&w=1920",
  leather_jacket: "https://images.unsplash.com/photo-1551028719-00167b16eac5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxsZWF0aGVyJTIwamFja2V0fGVufDB8fHx8MTc4MzUyMzYwMXww&ixlib=rb-4.1.0&q=85",
  folded_clothes: "https://images.pexels.com/photos/14642652/pexels-photo-14642652.jpeg",
  steam_press: "https://images.unsplash.com/photo-1740684589228-54b6fba08985?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxzdGVhbSUyMHByZXNzfGVufDB8fHx8MTc4MzUyMzYwMnww&ixlib=rb-4.1.0&q=85",
  fabric_texture: "https://images.unsplash.com/photo-1643313262988-cdc5f50c6019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmYWJyaWMlMjB0ZXh0dXJlfGVufDB8fHx8MTc4MzUyMzYwMnww&ixlib=rb-4.1.0&q=85",
};

export const SERVICES = [
  { id: "dry-cleaning", title: "Dry Cleaning", desc: "Solvent-based care for suits, sarees, silks and delicate fabrics that water cannot touch.", image: IMAGES.hero_rack },
  { id: "laundry", title: "Laundry & Wash", desc: "Everyday wash, fold and express laundry — crisp, fresh and precisely finished.", image: IMAGES.folded_clothes },
  { id: "leather", title: "Leather & Suede", desc: "Specialised restoration for leather jackets, bags and suede — colour and texture revived.", image: IMAGES.leather_jacket },
  { id: "steam-press", title: "Steam Press & Ironing", desc: "Industrial steam pressing for a sharp, tailored, showroom finish on every garment.", image: IMAGES.steam_press },
  { id: "home", title: "Home Furnishing", desc: "Curtains, blankets, bed sheets and upholstery cleaned at scale, sanitised and deodorised.", image: IMAGES.fabric_texture },
  { id: "repairs", title: "Garment Repairs", desc: "Alterations, mending and restoration by hand — extending the life of what you love.", image: IMAGES.hero_rack },
];

export const PRICING = [
  { item: "Shirt / Trouser", price: "₹60" },
  { item: "Suit (2 Piece)", price: "₹280" },
  { item: "Saree (Plain)", price: "₹250" },
  { item: "Saree (Designer)", price: "₹450" },
  { item: "Sherwani", price: "₹500" },
  { item: "Leather Jacket", price: "₹700" },
  { item: "Blanket (Single)", price: "₹300" },
  { item: "Blanket (Double)", price: "₹450" },
  { item: "Curtain (per sq ft)", price: "₹12" },
  { item: "Bed Sheet", price: "₹120" },
];

export const OFFERS = [
  { code: "FIRST20", title: "20% Off First Order", desc: "New customers get a flat 20% discount on their very first pickup.", tag: "New Customer" },
  { code: "FREEPICK", title: "Free Pickup & Delivery", desc: "Zero delivery charge across South Delhi on orders above ₹500.", tag: "Always On" },
  { code: "MONSOON", title: "Monsoon Blanket Care", desc: "Buy 2 blanket cleans, get 1 absolutely free this season.", tag: "Seasonal" },
];

export const MANIFESTO = [
  { no: "01", title: "We Schedule Your Pickup", body: "Book online or call. Our team arrives at your doorstep across South Delhi at a time that suits you — no queues, no waiting." },
  { no: "02", title: "We Treat Every Fibre", body: "Each garment is inspected, tagged and matched to the right process — solvent, steam or hand-finish — by people who genuinely care." },
  { no: "03", title: "We Return It Immaculate", body: "Pressed, protected and delivered back on schedule. Fresh, crisp and ready to wear. That is the Stainless promise." },
];

export const SERVICE_OPTIONS = SERVICES.map((s) => s.title).concat(["Wedding / Designer Wear", "Home Sanitization"]);
